var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailyUpsellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5297_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.94 6.59L23.06 10.98C22.59 13.31 20.53 15 18.16 15H6.73C7.15 16.18 8.26 17 9.56 17H19C19.55 17 20 17.45 20 18C20 18.55 19.55 19 19 19H9.56C7.03 19 4.89 17.1 4.59 14.58L3.21 2.88C3.15 2.38 2.72 2 2.22 2H1C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0H2.22C3.74 0 5.02 1.14 5.2 2.65L5.24 3H9C9.55 3 10 3.45 10 4C10 4.55 9.55 5 9 5H5.48L6.42 13H18.16C19.58 13 20.82 11.99 21.1 10.59L21.98 6.2C22.04 5.91 21.96 5.6 21.77 5.37C21.58 5.14 21.3 5 21 5H17C16.45 5 16 4.55 16 4C16 3.45 16.45 3 17 3H21C21.9 3 22.75 3.4 23.32 4.1C23.89 4.8 24.12 5.71 23.94 6.59ZM7 20C5.9 20 5 20.9 5 22C5 23.1 5.9 24 7 24C8.1 24 9 23.1 9 22C9 20.9 8.1 20 7 20ZM17 20C15.9 20 15 20.9 15 22C15 23.1 15.9 24 17 24C18.1 24 19 23.1 19 22C19 20.9 18.1 20 17 20ZM9.27 7.25C8.89 7.65 8.92 8.29 9.32 8.66L10.88 10.12C11.47 10.71 12.24 11 13.01 11C13.78 11 14.53 10.71 15.1 10.14L16.69 8.66C17.09 8.28 17.11 7.65 16.74 7.25C16.36 6.85 15.73 6.82 15.33 7.2L14.01 8.43V1C14.01 0.45 13.56 0 13.01 0C12.46 0 12.01 0.45 12.01 1V8.43L10.69 7.2C10.29 6.82 9.65 6.85 9.28 7.25H9.27Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5297_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyUpsellIcon);
export default __webpack_public_path__ + "static/media/daily-upsell-icon.5f27e4a23613c18559328368f789b25e.svg";
export { ForwardRef as ReactComponent };